import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import CategorySelector from "../Layouts/CategorySelector";
import Preview from "../Layouts/Preview";
import PrimaryBar from "../Layouts/PrimaryBar";
import SecondaryBar from "../Layouts/SecondaryBar";
import Header from "../Layouts/Header";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { configDataConstants, configurationConstants, tableInfoConstants, tableTypeConstants, } from "../store/actions/types";
import { useParams } from "react-router-dom";
import useUserConfiguration from "../utils/updateUserConfiguration";
import { ConfData3 as workStation } from "../const/const";
import { makeSessionRequest } from "../utils/makeSessionRequest";
function Configurator() {
    const [secondaryBarHidden, setSecondaryBarHidden] = useState(true);
    const [highlightSecondaryBar, setHighlightSecondaryBar] = useState(false);
    const [showCategorySelector, setShowCategorySelector] = useState(true);
    const [isStartingFromScratch, setIsStartingFromScratch] = useState(undefined);
    const [windowWidth, setWindowWidth] = useState();
    const productViewerRef = useRef();
    let { productId } = useParams();
    const dispatch = useAppDispatch();
    const { updateUserConfiguration } = useUserConfiguration();
    const currentOrder = useAppSelector((state) => state.orders.currentOrder);
    const userConfiguration2 = useAppSelector((state) => state.configuration.userConfiguration2);
    useEffect(() => {
        if (userConfiguration2.Legs !== "Colors") {
            dispatch({
                type: configurationConstants.DISABLE_FEATURES,
                payload: ["Color Options"],
            });
        }
    }, [dispatch, userConfiguration2]);
    const specs = useAppSelector((state) => state.configData.original);
    // const table = useAppSelector((state) => state.tableType.table);
    useEffect(() => {
        makeSessionRequest("configurator_view");
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        let userConfiguration;
        if ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items.length) === 0) {
            setIsStartingFromScratch(false);
        }
        if (productId) {
            setIsStartingFromScratch(false);
            userConfiguration =
                (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items) &&
                    productId &&
                    ((_a = currentOrder.cart_items[parseInt(productId || `${currentOrder.cart_items.length - 1 || 0}`)]) === null || _a === void 0 ? void 0 : _a.configuration);
        }
        else if (isStartingFromScratch === false &&
            (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items.length) > 0) {
            userConfiguration =
                (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items) && ((_b = currentOrder.cart_items[0]) === null || _b === void 0 ? void 0 : _b.configuration);
            dispatch({
                type: tableInfoConstants.SET_TABLE_INFO,
                payload: userConfiguration.Length && userConfiguration.Height
                    ? `${userConfiguration.Length}W x ${userConfiguration.Width}D`
                    : `${userConfiguration.Dia}Dia`,
            });
            dispatch({
                type: tableTypeConstants.SET_TABLE_TYPE,
                payload: userConfiguration.type === "SHARING" ||
                    userConfiguration.type === "NON SHARING"
                    ? "Linear Workstation"
                    : userConfiguration.Category,
            });
        }
        else if (currentOrder && currentOrder.cart_items.length === 0) {
            userConfiguration =
                (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items) &&
                    ((_c = currentOrder.cart_items[parseInt(productId || `${currentOrder.cart_items.length - 1 || 0}`)]) === null || _c === void 0 ? void 0 : _c.configuration);
        }
        if (!userConfiguration) {
            return;
        }
        else {
            if (userConfiguration.Legs === "Colors") {
                dispatch({
                    type: configurationConstants.ENABLE_FEATURES,
                    payload: ["Color Options"],
                });
            }
        }
        const Feature = specs.find((s) => s.name === "System");
        const subFeature = (_d = Feature === null || Feature === void 0 ? void 0 : Feature.options) === null || _d === void 0 ? void 0 : _d.find((s) => s.name === userConfiguration.type);
        const option = (_e = subFeature === null || subFeature === void 0 ? void 0 : subFeature.options) === null || _e === void 0 ? void 0 : _e.find((s) => s.size === userConfiguration.noOfSeats);
        option &&
            updateUserConfiguration("System", {
                name: (subFeature === null || subFeature === void 0 ? void 0 : subFeature.name) || "",
                option,
            });
        // to dynamically enable and disable options available for a feature from the configuration
        for (const config of specs) {
            // Assert that config.options is an array of Option.
            const configOptions = config.options;
            const currentType = userConfiguration.type;
            console.log("configOptions", configOptions);
            // Now filter works as expected because configOptions is known to be Option[]
            const currentTypeDetailsList = configOptions.filter((value) => value.name === currentType);
            if (currentTypeDetailsList.length > 0) {
                const currentTypeDetails = currentTypeDetailsList[0];
                // Assert that currentTypeDetails.options is an array of Option.
                const currentTypeDetailsOptions = currentTypeDetails.options;
                for (const currentTypeDetailsOptionsValue of currentTypeDetailsOptions) {
                    const optionName = currentTypeDetailsOptionsValue.name;
                    // Assert that the nested options are also Option[].
                    const optionOptions = currentTypeDetailsOptionsValue.options;
                    const selectedConfig = userConfiguration[optionName];
                    if (selectedConfig) {
                        const matchingOptions = optionOptions.filter((value) => selectedConfig === value.name);
                        if (matchingOptions.length > 0) {
                            const selectedOption = matchingOptions[0];
                            const disableOptions = selectedOption.disableOptions;
                            const enableOptions = selectedOption.enableOptions;
                            if (disableOptions) {
                                dispatch({
                                    type: configurationConstants.DISABLE_OPTIONS,
                                    payload: disableOptions,
                                });
                            }
                            if (enableOptions) {
                                dispatch({
                                    type: configurationConstants.ENABLE_OPTIONS,
                                    payload: enableOptions,
                                });
                            }
                        }
                    }
                }
            }
        }
        dispatch({
            type: configurationConstants.UPDATE_CONFIGURATION2,
            payload: Object.assign({}, userConfiguration),
        });
        setShowCategorySelector(false);
        //causes infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productId, currentOrder, specs, isStartingFromScratch]);
    useEffect(() => {
        if (currentOrder && currentOrder.cart_items.length === 0) {
            dispatch({
                type: configDataConstants.SET_CONFIG_DATA,
                payload: workStation,
            });
        }
    }, [currentOrder, dispatch]);
    useEffect(() => {
        return () => {
            dispatch({
                type: configurationConstants.SET_CONFIGURATION,
                payload: null,
            });
            dispatch({
                type: configurationConstants.RESET_CONFIGURATION,
            });
        };
    }, [currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cart_items, dispatch]);
    useEffect(() => {
        window.addEventListener("resize", () => {
            setWindowWidth(window.innerWidth);
        });
        return () => { };
    }, []);
    const blinkSecondaryBar = () => {
        setHighlightSecondaryBar(true);
        const interval = 150;
        setTimeout(() => {
            setHighlightSecondaryBar(false);
        }, interval);
        setTimeout(() => {
            setHighlightSecondaryBar(true);
        }, interval * 2);
        setTimeout(() => {
            setHighlightSecondaryBar(false);
        }, interval * 3);
    };
    const closeSecondaryBar = () => {
        setSecondaryBarHidden(true);
    };
    if ((windowWidth && windowWidth < 400) || window.innerWidth < 400) {
        return (_jsx("div", Object.assign({ className: "flex h-screen items-center justify-center" }, { children: "please switch to landscape mode" })));
    }
    return (_jsx("div", Object.assign({ style: { backgroundColor: "#fff", height: window.innerHeight }, className: "App" }, { children: _jsx("div", Object.assign({ className: "flex overflow-hidden overflow-y-auto w-screen flex-col h-full relative" }, { children: showCategorySelector ? (_jsx(CategorySelector, { setShowCategorySelector: setShowCategorySelector, setIsStartingFromScratch: setIsStartingFromScratch, isStartingFromScratch: isStartingFromScratch })) : (_jsxs("div", Object.assign({ className: "h-full flex items-center" }, { children: [_jsx(Header, { productViewerRef: productViewerRef }), _jsx(Preview, { productViewerRef: productViewerRef }), _jsx(PrimaryBar, { secondaryBarHidden: secondaryBarHidden, setSecondaryBarHidden: setSecondaryBarHidden, blinkSecondaryBar: blinkSecondaryBar }), _jsx(SecondaryBar, { closeSecondaryBar: closeSecondaryBar, secondaryBarHidden: secondaryBarHidden, highlightSecondaryBar: highlightSecondaryBar })] }))) })) })));
}
export default Configurator;
